const state = {
  showUploadDialog: false,
  currentFilePath: '',
};

const getters = {};

const mutations = {
  setUploadDialogState: (st, data) => {
    st.showUploadDialog = data;
  },
};

const actions = {
  setUploadDialogState({ commit }, payload) {
    commit('setUploadDialogState', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};